import React, { Fragment } from 'react';
import classNames from 'classnames/bind';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './assets/styles.scss';
import { useDesktopLargeOnly } from '../../helpers/responsive';

import 'swiper/swiper.scss';

import IconTestimonials from './assets/images/testimonials-icon.svg?inline';
import IconQuote from './assets/images/quote-icon.svg?inline';

const cx = classNames.bind(styles);

const testimonials = [
  {
    title: '100% Transparency',
    text:
      'I can say the innovation behind Peergame is nothing short of incredible.'
      + ' You can’t beat the on-chain experience with its provably fair games, 100% transparency, instant payouts.',
    authorName: 'Becky Liggero',
    authorSource: 'Ayre Media',
  },
  {
    title: 'Like a real casino',
    text:
      'I’ve used many online casinos over the years. None of them rival the experience that Peergame offers.'
      + ' Like a real casino, you can walk away with your winnings at any point.',
    authorName: 'Brandon Cryderman',
    authorSource: 'HandCash',
  },
  {
    title: 'Simply Amazing',
    text:
      'I can say without doubt that Peergame is the BEST platform I\'ve played online. It\'s just a bonus'
      + ' it utilises the BSV blockchain. Almost instant play and payouts to your own self-custodial wallet. ',
    authorName: 'Zatoshi',
    authorSource: 'Zatoshi.io',
  },
  {
    title: 'Unique Experience',
    text:
      'Have been working with a lot of casinos throughout the years but none offering such exclusive and '
      + 'unique services on the market. Just give it a try and you will not regret it.',
    authorName: 'I. C. Daniel',
    authorSource: 'BeerMoneyForum.com',
  },
];

export default function Testimonials() {
  const isDesktopLargeOnly = useDesktopLargeOnly();

  return (
    <Fragment>
      <div className={cx('icon-heading')}>
        <IconTestimonials />
        <h3>TESTIMONIALS</h3>
      </div>
      <Swiper
        className={cx('testimonials')}
        spaceBetween={16}
        slidesPerView="auto"
        simulateTouch
        allowTouchMove={!isDesktopLargeOnly}
      >
        {testimonials.map(({
          title, text, authorName, authorSource,
        }) => (
          <SwiperSlide key={title.toLowerCase()} className={cx('card')}>
            <IconQuote />
            <h5>{title}</h5>
            <p className={cx('small')}>{text}</p>
            <span className={cx('small', 'bold')}>{authorName}</span>
            <br />
            <span className={cx('small')}>{authorSource}</span>
          </SwiperSlide>
        ))}
      </Swiper>
    </Fragment>
  );
}
